var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoTrofeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1672_28499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1389 0H8.86111C7.52691 0 6.43941 1.06445 6.48976 2.35352C6.49983 2.6123 6.5099 2.87109 6.525 3.125H1.20833C0.538715 3.125 0 3.64746 0 4.29688C0 8.81836 1.68663 11.9629 3.95226 14.0967C6.18264 16.2012 8.90139 17.2607 10.9052 17.7979C12.0833 18.1152 12.8889 19.0674 12.8889 20.0244C12.8889 21.0449 12.033 21.875 10.9807 21.875H9.66667C8.77552 21.875 8.05556 22.5732 8.05556 23.4375C8.05556 24.3018 8.77552 25 9.66667 25H19.3333C20.2245 25 20.9444 24.3018 20.9444 23.4375C20.9444 22.5732 20.2245 21.875 19.3333 21.875H18.0193C16.967 21.875 16.1111 21.0449 16.1111 20.0244C16.1111 19.0674 16.9116 18.1104 18.0948 17.7979C20.1036 17.2607 22.8224 16.2012 25.0528 14.0967C27.3134 11.9629 29 8.81836 29 4.29688C29 3.64746 28.4613 3.125 27.7917 3.125H22.475C22.4901 2.87109 22.5002 2.61719 22.5102 2.35352C22.5606 1.06445 21.4731 0 20.1389 0ZM2.46198 5.46875H6.71129C7.16945 9.86816 8.18142 12.8076 9.32431 14.7754C8.07066 14.2383 6.76667 13.4814 5.63889 12.417C4.02778 10.8984 2.71875 8.70605 2.46701 5.46875H2.46198ZM23.3661 12.417C22.2384 13.4814 20.9344 14.2383 19.6807 14.7754C20.8236 12.8076 21.8356 9.86816 22.2938 5.46875H26.5431C26.2863 8.70605 24.9773 10.8984 23.3712 12.417H23.3661Z",
    fill: "url(#paint0_linear_1672_28499)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1672_28499",
    x1: 30.6627,
    y1: -1.47783,
    x2: 24.9616,
    y2: 29.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1672_28499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTrofeo);
export default __webpack_public_path__ + "static/media/icono-trofeo.936c01b8f2a7977024b9b466355e3a92.svg";
export { ForwardRef as ReactComponent };